import { Component, OnInit } from '@angular/core';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { Navigator } from '../../menu/navigator';
import { LobbyNavigator } from 'src/app/services/lobby/lobby-navigator.service';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-site-logo',
  templateUrl: './site-logo.component.html',
  styleUrls: ['./site-logo.component.scss']
})

export class SiteLogoComponent implements OnInit {

  public navbarLogoRegulatoryActive: boolean;
  public navbarLogoRegulatoryURL: string;
  public navbarLogoRegulatoryImage: string;

  constructor(
    public appLinks: AppLinksService,
    public configService: ConfigService,
    private lobbyNavigator: LobbyNavigator,
    private navigator: Navigator,
    private platform: Platform
  ) { }

  ngOnInit(): void {
    const navbarLogoRegulatoryConfig: any = this.configService.getExternalLinks().payload.filter(link => link?.code === "navbar_logo_regulatory" && link?.isActive === 1)[0];
    this.navbarLogoRegulatoryActive = navbarLogoRegulatoryConfig?.isActive === 1;
    const iconName = navbarLogoRegulatoryConfig?.iconName;
    this.navbarLogoRegulatoryImage = `${this.configService.getConfig()?.CDN_BASEURL}/assets/icon/${iconName}`;
    this.navbarLogoRegulatoryURL = navbarLogoRegulatoryConfig?.url;
  }

  protected onLogoClick(): any {
    this.lobbyNavigator.setKeyword(this.lobbyNavigator.getCasinoDefaultKeyword());
    if(this.platform.is('capacitor')){
      this.navigator.navigateToCasinoFromLogoClick();
    }else{
      this.navigator.toTab("casino",false, this.lobbyNavigator.getCasinoDefaultKeyword()?.keyword_route);
    }
  }

  public onNavbarLogoRegulatory(): any {
    this.appLinks.openExternalPage(this.navbarLogoRegulatoryURL);
  }

}